import {
  formatAppDateTime,
  hasAppDateTime,
  normalizeDateInput,
} from "./appDateTime";

export { normalizeDateInput };

export function formatAccountDateTime(value, options = {}) {
  return formatAppDateTime(value, options);
}

export function hasAccountDateTime(value) {
  return hasAppDateTime(value);
}
